import { useShallow } from 'zustand/react/shallow'

import { useAppStore } from '@/store/useAppStore'

import { Spinner } from '../ui/spinner'

type LoadingSpinnerProps = {
  /**
   * ローディング表示を強制的に表示する
   */
  loading?: boolean
  /**
   * サイズ（デフォルト: 100）
   */
  size?: number
  /**
   * メッセージ
   */
  message?: string
  /**
   * フルスクリーン表示（デフォルト: true）
   */
  fullscreen?: boolean
  /**
   * カード内に表示（デフォルト: false）
   */
  inCard?: boolean
}

/**
 * グローバルまたはローカルのローディング表示コンポーネント
 *
 * - グローバル: useAppStoreのloading状態を監視
 * - ローカル: loading propsで制御
 */
export const LoadingSpinner = ({
  loading: localLoading,
  size = 100,
  message,
  fullscreen = true,
  inCard = false,
}: LoadingSpinnerProps = {}) => {
  const globalLoading = useAppStore(useShallow((state) => state.loading))

  const isLoading = localLoading !== undefined ? localLoading : globalLoading > 0

  if (!isLoading) return null

  const spinnerContent = (
    <div className="flex flex-col items-center gap-4">
      <Spinner size={size} />
      {message && <span className="text-muted-foreground">{message}</span>}
    </div>
  )

  if (inCard) {
    return (
      <div className="bg-card rounded-lg p-6 shadow-md h-full flex items-center justify-center">{spinnerContent}</div>
    )
  }

  if (fullscreen) {
    return (
      <div className="absolute top-1/2 left-1/2 z-50 transform -translate-x-1/2 -translate-y-1/2">{spinnerContent}</div>
    )
  }

  return spinnerContent
}
